import React, { useState, useEffect } from 'react';
import { api, globalErrorHandler } from '../../api/create-api';
import { Row, Col, Table, Badge } from 'reactstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTimes } from '@fortawesome/free-solid-svg-icons';
//import { SearchBar } from '@galop/component-library';
import { makeCall } from '../../auth-utils';
import { EMPTY_GUID } from '../../Helpers/Helper';
import { ViewProperty } from './ViewProperty';
import { useBSToasts } from '../Shared/BSToasts';
import { SearchBar } from '@galop/component-library';

export const PropertyList = (props) => {
    const { config, IsDirty, Search, NewResource, CloseNewResource, ShowResource } = props;
    const [toasts, addToast, removeToast] = useBSToasts([]);
    const { CurrentUser } = props;
    const [loading, setLoading] = useState(false);//!props.resources);
    const [filtered, setFiltered] = useState(Search || '');
    const [resources, setResources] = useState(props.resources || []);
    const [resourceList, setResourceList] = useState([]);
    const [filteredResources, setFilteredResources] = useState([]);
    const [viewResource, setViewResource] = useState(null);
    const [resourceIsDirty, setResourceIsDirty] = useState(false);
    const [changedResourceIds, setChangedResourceIds] = useState([]);
    const [gsrCompanies, setGSRCompanies] = useState(null);
    const otherAsset = { id: 99, new: true };

    useEffect(() => {
        if (IsDirty && typeof IsDirty === 'function') {
            IsDirty(resourceIsDirty);
        }
    }, [resourceIsDirty]);

    useEffect(() => setResources(props.resources), [props.resources]);

    useEffect(() => {
        getResources(false);
    }, [CurrentUser]);

    useEffect(() => {
        filterResources(resources);
    }, [filtered, resources]);

    useEffect(() => {
        if (!viewResource && ShowResource && resources.find(resource => resource.id === ShowResource)) {
            setViewResource(resources.find(resource => resource.id === ShowResource));
        }
        else if (viewResource && resources.find(resource => resource.id === viewResource.id)) {
            setViewResource(resources.find(resource => resource.id === viewResource.id));
        }
    }, [resources]);

    const getResources = (loadFullObjects) => {
        if (CurrentUser) {
            makeCall(async (authHeader) => {
                if (!loadFullObjects) {
                    addToast(`Loading ${config.pluralCapitalResourceName()}`, { appearance: 'info', id: 'loading-resources' });
                }
                const result = await api(`api/${config.controllerName}?loadFullObject=${loadFullObjects}&showDeleted=true`, {
                    headers: authHeader
                })
                    .catch(error => globalErrorHandler(error, addToast));

                if (result && result.data) {
                    if (!loadFullObjects) {
                        getResources(!loadFullObjects);

                        const data = result.data.map(result => ({ ...result, loaded: false }));

                        setResources(data);
                        setFilteredResources(data);
                    }
                    else {
                        const data = result.data.map(result => ({ ...result, loaded: true }));

                        setResources(data);
                        setFilteredResources(data);
                    }
                }
                removeToast('loading-resources', () => {
                    setLoading(false);
                });
            });
        }
    };

    const filterResources = (unfiltered) => {
        let filteredList = [];

        if (filtered !== "") {
            filteredList = unfiltered.filter(resource => {
                const lcFilter = filtered.toLowerCase();

                // Search by table columns
                const name = (resource.name || '').toLowerCase(); // Name
                const assetName = (resource.assetName || '').toLowerCase(); // Name


                return name.includes(lcFilter)
                    || assetName.includes(lcFilter);
            });
        }
        else {
            filteredList = unfiltered;
        }

        setFilteredResources(filteredList);
    };

    const updateAsset = (resource) => {
        const newAssets = resources;
        if (resource && typeof resource === 'object') { /* Save */
            const assetInList = resources.find(ast => ast.id === resource.id);
            const index = resources.indexOf(assetInList);

            if (index > -1) {
                newAssets[index] = resource;
            }
            else {
                newAssets.push(resource);
            }
        }
        else { /* Delete */
            const assetInList = resources.find(ast => ast.id === resource);
            const index = resources.indexOf(assetInList);

            newAssets.splice(index, 1);
        }
        setResources([...newAssets]);
    };

    const changeAsset = (resource) => {
        if (!resourceIsDirty) {
            setViewResource((viewResource || {}).id !== resource.id ? resource : null);
        }
    };

    const addPMAsset = (propertyNumber) => {
        if (!viewResource || (viewResource.id !== propertyNumber)) {
            makeCall(async (authHeader) => {
                addToast(`Loading ${config.pluralCapitalResourceName()} from GSR`, { appearance: 'info', id: 'loading-resource' });
                const result = await api(`/api/${config.controllerName}/gsr-companies/${propertyNumber}`, { headers: authHeader })
                    .catch(error => console.log('error', error));

                if (result && result.data) {
                    result.data.id = propertyNumber;
                    result.data.new = true;
                    setViewResource(result.data);
                }
                removeToast('loading-resource');
            });
        }
        else {
            setViewResource(null);
        }
    }

    return (!loading &&
        <div className="flex-fill h-75 pb-5 pb-sm-3">
            <Row className="h-100">
                <Col md="4" lg="3" className={`h-100 flex-column ${viewResource || NewResource ? 'd-none d-md-flex' : 'd-flex '}`}>
                    <div className={`py-1 ${viewResource ? 'd-none d-md-block' : ''}`}>
                        <div>
                            <SearchBar value={filtered} onChange={(value) => setFiltered(value)} placeHolder={`Search ${config.pluralCapitalResourceName()}`} Reset={() => setFiltered('')} />
                            {config.showHelp &&
                                <p className="mt-2">Use this screen to view / edit {config.pluralResourceName()} in this system.</p>
                            }
                        </div>
                    </div>
                    {config.listHeader &&
                        <div className={`text-primary align-middle mb-1 ${viewResource || NewResource ? 'd-none d-md-block' : ''}`}>
                            <span className="h3">{NewResource ? `New ${config.capitalResourceName}` : config.listHeader}</span>
                        </div>
                    }
                    <div className={`flex-fill border rounded scrollable-list ${viewResource || NewResource ? 'd-none d-md-block' : ''}`} style={{ overflowX: 'hidden', overflowY: 'auto' }}>
                        <Table hover={!resourceIsDirty} className={`mb-0 border-bottom`}>
                            <tbody>
                                {NewResource && ([otherAsset]).map(resource => <tr key={resource.id || Math.random()} className={`${resourceIsDirty ? '' : 'cursor-pointer'} ${resource.id === (viewResource || {}).id ? 'bg-secondary text-white' : ''}`} onClick={() => changeAsset(resource)}>
                                    <td className={`${!resource.id ? 'fst-italic' : ''} align-middle`}>
                                        <span className={`${resource.id === (viewResource || {}).id ? 'text-white' : ''}`}>Other {config.capitalResourceName}</span>
                                        {resource.id === (viewResource || {}).id && <span className="float-end text-white"><FontAwesomeIcon icon={faTimes} /> Close</span>}
                                    </td>
                                </tr>)
                                }
                                {NewResource && gsrCompanies && <tr><td className="bg-off-white shadow py-1">GSR Companies</td></tr>}
                                {(filteredResources || []).map(resource => (
                                    <tr key={resource.id || Math.random()} className={`${resourceIsDirty ? '' : 'cursor-pointer'} ${resource.id === (viewResource || {}).id ? 'bg-secondary text-white' : resource.deleted ? 'bg-light text-muted' : ''}`} onClick={() => {
                                        if (typeof resource.id === 'number' && resource.name) {
                                            addPMAsset(resource.id);
                                        }
                                        else {
                                            changeAsset(resource);
                                        }
                                    }}>
                                        <td className={`${!resource.id ? 'fst-italic' : ''} align-middle`}>
                                            <span className={`${resource.id === (viewResource || {}).id ? 'text-white' : ''}`}>{resource.name}</span>
                                            {changedResourceIds.find(changed => changed === resource.id) && (!viewResource || resource.id !== viewResource.id) && <Badge className="ms-1 shadow-sm" color="secondary">Update</Badge>}
                                            {resource.id === (viewResource || {}).id && <span className="float-end text-white"><FontAwesomeIcon icon={faTimes} /> Close</span>}
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </Table>
                    </div>
                </Col>
                <Col className={`${viewResource ? 'border-start h-100' : ''}`}>
                    {(viewResource) &&
                        <ViewProperty key={`${(viewResource || {}).id || EMPTY_GUID}_${(viewResource || {}).loaded}`}
                            userId={CurrentUser.id}
                            {...{
                                config,
                                resource: viewResource,
                                NewResource,
                                resources: resourceList
                            }}
                            Save={(resource) => {
                                if (CloseNewResource && typeof CloseNewResource === 'function') {
                                    CloseNewResource();
                                }
                                updateAsset(resource);
                                viewResource.id = resource.id;
                            }}
                            Close={() => {
                                if (CloseNewResource && typeof CloseNewResource === 'function') {
                                    CloseNewResource();
                                }
                                setViewResource(null);
                                setResourceIsDirty(false);
                            }}
                            IsDirty={(isDirty) => setResourceIsDirty(isDirty)}
                            Changed={!!changedResourceIds.find(changed => changed === viewResource.id)}
                            ReloadResources={() => getResources(true)}
                        />
                    }
                </Col>
            </Row>
            {toasts}
        </div>
    );
};


// WEBPACK FOOTER //
// ./src/components/Properties/PropertyList.js